<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section-4">
<h1>5</h1>
<p>We men come in for a lot of criticism from our wives/partners/loved ones (delete where not appropriate). It’s normally about romance, or our perceived lack of it.</p>
<p>“Why is it,” Jess starts tonight, “that you only tell me you love me after I’ve first said I love you?”</p>
<p>“Because you’re a lady,” is my glib response, “and I’m a gentleman. And it’s always ladies before gentlemen.”</p>
<p>Well, it used to be. But her expression tells me what I already know, that she’s not very impressed by the answer.</p>
<p>“Okay then. If you love me, how do you know?” She finally says.</p>
<p>I know I’m likely to be digging myself a big hole but I can’t help myself. So I say: “Because I enjoy being with you, I suppose. Because I get a warm feeling when I think about you. Because I only want good things for you and you’re the best person I’ve ever met.”</p>
<p>“Really? Better than your mother? Surely not.”</p>
<p>“I’m not getting into that,” I rely with some desperation. “We don’t meet our mothers. They’re just there when we become aware of things. And they’re always there when we need them if we’re lucky.”</p>
<p>It’s all just banter really and it generally goes on until something interesting comes on television. Which these days means it can go on a long time.</p>
<p>But tonight, I end it early by changing the subject. “What about the woman?” I ask.</p>
<p>“What woman? Do you mean the one on the bridge?”</p>
<p>“Who else? What are we going to do about her?”</p>
<p>She looks at me with a puzzled, even exasperated, expression. “There’s nothing to do. She fell, it’s being treated as suicide, end of story.”</p>
<p>“But aren’t you bothered why she did it? I’m bothered and it’s preying on my mind, as you know only too well. There has to be a reason, and if I can find what it is, it might sort me out. Don’t you want to do that?”</p>
<p>“Of course I do. I’m surprised you even asked. But we know why she did it. It’s because she was depressed. She had a long history of depression. That’s what they’re saying. It’s possibly something to do with her time in Bosnia, maybe something to do with the war.”</p>
<p>“You’re right,” I say, suitably encouraged. “It could have been something to do with the war. But that was a long time ago, so why kill herself now? What’s changed all of a sudden?”</p>
<p>“I don’t know what’s changed, if anything. Maybe it all just got on top of her and she finally cracked. We’ll probably never know.”</p>
<p>“We won’t if we don’t try to find out,” I protest. “Maybe we should at least make the attempt.”</p>
<p>“And how do you propose to do that?” she asks, ever the practical one.</p>
<p>I was hoping she might have a suggestion, might help me out, so I can only reply: “I don’t really know.”</p>
<p>And I don’t, so I’ve hit an obstruction already. But I’m determined to find a way.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?c0751cfa